'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = exports.klaviyoTrackItemAdd = exports.klaviyoTrackItemView = undefined;

var _Helpers = require('scripts/components/Helpers');

var getKlaviyoItemData = function getKlaviyoItemData() {
  var product = window.bva.activeProduct || window.bva.product.data;
  var variant = product.variants[0];
  var image = product.image ? product.image.src : product.featured_image;
  return {
    Name: product.title,
    ProductID: product.id,
    Categories: product.collections,
    ImageURL: 'https:' + image,
    URL: product.url,
    Brand: product.vendor,
    Price: (0, _Helpers.formatMoney)(variant.price, '${{amount}}'),
    CompareAtPrice: variant.compare_at_price ? (0, _Helpers.formatMoney)(variant.compare_at_price, '${{amount}}') : null
  };
}; // Components
var klaviyoTrackItemView = exports.klaviyoTrackItemView = function klaviyoTrackItemView() {
  var _window = window,
      _window$_learnq = _window._learnq,
      loaded = _window$_learnq === undefined ? false : _window$_learnq;

  if (!loaded) {
    return setTimeout(klaviyoTrackItemView, 1000);
  }
  var item = getKlaviyoItemData();
  window._learnq.push(['track', 'Viewed Product', item]);
  window._learnq.push(['trackViewedItem', {
    Title: item.Name,
    ItemId: item.ProductID,
    Categories: item.Categories,
    ImageUrl: item.ImageURL,
    Url: item.URL,
    Metadata: {
      Brand: item.Brand,
      Price: item.Price,
      CompareAtPrice: item.CompareAtPrice
    }
  }]);
};

var klaviyoTrackItemAdd = exports.klaviyoTrackItemAdd = function klaviyoTrackItemAdd() {
  var _window2 = window,
      _window2$_learnq = _window2._learnq,
      loaded = _window2$_learnq === undefined ? false : _window2$_learnq;

  if (!loaded) {
    return setTimeout(klaviyoTrackItemAdd, 1000);
  }
  var item = getKlaviyoItemData();
  window._learnq.push(['track', 'Add To Cart', item]);
};

var loadKlaviyoScript = function loadKlaviyoScript() {
  var script = document.createElement('script');
  script.src = '//www.klaviyo.com/media/js/public/klaviyo_subscribe.js';
  script.onload = bindUIActions;
  document.head.appendChild(script);
};

var bindUIActions = function bindUIActions() {
  KlaviyoSubscribe.attachToForms('[email-capture]', {
    hide_form_on_success: false
  });
  KlaviyoSubscribe.attachToForms('[oos-capture]', {
    hide_form_on_success: false,
    success_message: 'Thanks for joining. More is on the way!'
  });
};

var init = exports.init = function init() {
  loadKlaviyoScript();
  console.log('[BVA] Component Loaded: Klaviyo');
};